export const contactEn = {
  embed: {
    infoTitle: 'Contact information',
    phone: 'Phone',
    email: 'Email',
    scheduleTitle: 'Business hours',
    scheduleWeekdays: 'Monday to Friday: 9:00 AM - 6:00 PM',
    scheduleSaturday: 'Saturday: 10:00 AM - 2:00 PM',
  },
};
